import { colors } from './colors';

import { css } from 'styled-components';

export const placeholderStyles = css`
  color: ${colors.gray1};
`;
